import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { Moment } from 'moment';

import * as models from '../../models';

@Component({
    selector: "process-status-cell",
    template: `{{text}}`,
    styles: [],
    standalone: false
})
export class ProcessStatusCellComponent implements ICellRendererAngularComp {
    private params: any;

    text: string;

    constructor() { }

    agInit(params: any): void {
        if (params.value == null) {
            return;
        }
        this.params = params;

        switch (this.params.value) {
            case models.ProcessStatus.Requested:
                this.text = 'Requested'
                break;
            case models.ProcessStatus.InProgress:
                this.text = 'In Progress'
                break;
            case models.ProcessStatus.Completed:
                this.text = 'Completed'
                break;
            case models.ProcessStatus.Error:
                this.text = 'Error'
                break;
            case models.ProcessStatus.RevertingInProgress:
                this.text = 'Reverting In Progress'
                break;
            case models.ProcessStatus.RevertCompleted:
                this.text = 'Revert Completed'
                break;
            default:
                console.log(`ProcessTypeCellComponent needs updating for ${this.params.value}`);
        }
    }

    refresh(params: any): boolean {
        return false;
    }
}